import React from 'react'
import { Link } from 'react-router-dom'

const SECTIONS = [
  {
    title: '1. Acceptance of Terms',
    content: `By accessing or using the Loan Closing Agent LLC platform ("Service"), you agree to be bound by these Terms of Service ("Terms"). If you do not agree to these Terms, please do not use our Service. These Terms apply to all users including clients, notary signing agents, and visitors.`
  },
  {
    title: '2. Description of Service',
    content: `Loan Closing Agent LLC ("LCA", "we", "us", or "our") is a nationwide mobile notary signing agency that connects clients with certified notary signing agents. We facilitate the scheduling, coordination, and completion of notarization services including but not limited to loan signings, affidavits, power of attorney documents, and other legal documents requiring notarization.`
  },
  {
    title: '3. User Accounts',
    content: `To access certain features of our platform, you must create an account. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. You agree to notify us immediately of any unauthorized use of your account. We reserve the right to terminate accounts that violate these Terms.`
  },
  {
    title: '4. Notary Services',
    content: `LCA coordinates notary signing services through a network of independent contractor notary signing agents. All notaries on our platform are independently verified for valid commission, E&O insurance, and background checks. However, LCA does not guarantee the outcome of any notarization or signing. Notary signing agents are independent contractors, not employees of LCA.`
  },
  {
    title: '5. Fees and Payment',
    content: `Service fees are disclosed prior to confirmation of any order. Payment is due upon completion of services unless otherwise agreed in writing. All fees are in US dollars. Veterans and active military personnel may be eligible for a 50% discount upon verification. LCA reserves the right to modify pricing at any time with reasonable notice. Refunds are handled on a case-by-case basis.`
  },
  {
    title: '6. Cancellation Policy',
    content: `Cancellations made more than 24 hours before a scheduled signing will receive a full refund. Cancellations made within 24 hours of a scheduled signing may be subject to a cancellation fee of up to 50% of the service fee to compensate the assigned notary for their time. Same-day cancellations or no-shows will be charged the full service fee. Rush orders are non-refundable once a notary has been assigned.`
  },
  {
    title: '7. Independent Contractor Relationship',
    content: `Notary signing agents who register on the LCA platform are independent contractors. Nothing in these Terms creates an employment, partnership, joint venture, or franchise relationship between LCA and any notary. Notaries are responsible for their own taxes, insurance, and compliance with applicable laws and regulations in their state of commission.`
  },
  {
    title: '8. Confidentiality',
    content: `All parties agree to maintain strict confidentiality regarding borrower information, loan details, and any non-public personal information encountered during the course of providing services. Notaries must comply with all applicable privacy laws including but not limited to the Gramm-Leach-Bliley Act (GLBA). Client information will not be shared with third parties except as necessary to provide the requested services or as required by law.`
  },
  {
    title: '9. Document Retention',
    content: `Uploaded documents are retained for a period of 60 days following completion of services, after which they are automatically deleted from our systems. Users are responsible for maintaining their own copies of all important documents. LCA is not responsible for documents that are lost or inaccessible after the retention period.`
  },
  {
    title: '10. Limitation of Liability',
    content: `To the maximum extent permitted by applicable law, LCA shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising out of or relating to your use of our Service. Our total liability for any claim arising out of these Terms shall not exceed the amount paid by you for the specific service giving rise to the claim in the 30 days preceding the claim.`
  },
  {
    title: '11. Indemnification',
    content: `You agree to indemnify and hold harmless Loan Closing Agent LLC, its officers, directors, employees, and agents from any claims, damages, losses, liabilities, costs, and expenses (including reasonable attorneys' fees) arising out of or relating to your use of the Service, your violation of these Terms, or your violation of any rights of another party.`
  },
  {
    title: '12. Governing Law',
    content: `These Terms shall be governed by and construed in accordance with the laws of the State of Florida, without regard to its conflict of law provisions. Any disputes arising under these Terms shall be subject to the exclusive jurisdiction of the state and federal courts located in Duval County, Florida.`
  },
  {
    title: '13. Modifications',
    content: `LCA reserves the right to modify these Terms at any time. We will notify registered users of material changes via email. Your continued use of the Service after such modifications constitutes your acceptance of the updated Terms. We encourage you to review these Terms periodically.`
  },
  {
    title: '14. Contact Information',
    content: `If you have any questions about these Terms of Service, please contact us at:\n\nLoan Closing Agent LLC\nNancy Phillips, Founder & CEO\nJacksonville, Florida\nPhone: (904) 865-0133\nEmail: nancy@loanclosingagent.com\nWebsite: loanclosingagent.com`
  },
]

export default function TermsOfService() {
  const styles = `
    @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@400;500;600&family=DM+Sans:wght@300;400;500&display=swap');
    * { box-sizing: border-box; margin: 0; padding: 0; }
    body { font-family: 'DM Sans', sans-serif; background: #0D1B3E; }
    :focus-visible { outline: 2px solid #C9A84C; outline-offset: 3px; border-radius: 4px; }
    .tos-nav { background: rgba(13,27,62,0.97); padding: 16px 48px; display: flex; align-items: center; justify-content: space-between; border-bottom: 1px solid rgba(201,168,76,0.2); position: sticky; top: 0; z-index: 100; }
    .tos-brand { font-family: 'Cormorant Garamond', serif; font-size: 18px; color: #C9A84C; text-decoration: none; font-weight: 500; }
    .tos-back { font-size: 12px; color: rgba(255,255,255,0.5); text-decoration: none; }
    .tos-back:hover { color: #C9A84C; }
    .tos-hero { background: #0D1B3E; padding: 48px 0 32px; text-align: center; border-bottom: 1px solid rgba(255,255,255,0.06); }
    .tos-hero h1 { font-family: 'Cormorant Garamond', serif; font-size: 36px; font-weight: 400; color: #fff; margin-bottom: 8px; }
    .tos-hero-sub { font-size: 13px; color: rgba(255,255,255,0.4); }
    .tos-hero-gold { color: #C9A84C; display: block; width: 40px; height: 1px; background: #C9A84C; margin: 16px auto; }
    .tos-body { background: #F8F7F4; min-height: 100vh; }
    .tos-wrap { max-width: 760px; margin: 0 auto; padding: 48px 24px 80px; }
    .tos-section { margin-bottom: 36px; }
    .tos-section h2 { font-size: 15px; font-weight: 600; color: #0D1B3E; margin-bottom: 12px; padding-bottom: 8px; border-bottom: 2px solid #C9A84C; display: inline-block; }
    .tos-section p { font-size: 14px; color: #4A4840; line-height: 1.8; white-space: pre-line; }
    .tos-footer { background: #0D1B3E; padding: 24px; text-align: center; border-top: 1px solid rgba(201,168,76,0.15); }
    .tos-footer-links { display: flex; gap: 24px; justify-content: center; flex-wrap: wrap; }
    .tos-footer-links a { font-size: 12px; color: rgba(255,255,255,0.4); text-decoration: none; }
    .tos-footer-links a:hover { color: #C9A84C; }
    .tos-updated { font-size: 11px; color: rgba(255,255,255,0.25); margin-top: 12px; }
    @media(max-width:640px){ .tos-hero h1 { font-size: 26px; } .tos-nav { padding: 14px 20px; } }
  `

  return (
    <div style={{ background: '#0D1B3E', minHeight: '100vh' }}>
      <style>{styles}</style>

      {/* Nav */}
      <nav className="tos-nav">
        <Link to="/" className="tos-brand">Loan Closing Agent LLC</Link>
        <Link to="/" className="tos-back">← Back to Home</Link>
      </nav>

      {/* Hero */}
      <div className="tos-hero">
        <div style={{ fontSize: 10, letterSpacing: '0.2em', color: '#C9A84C', marginBottom: 12 }}>LEGAL</div>
        <span className="tos-hero-gold" aria-hidden="true" />
        <h1>Terms of Service</h1>
        <p className="tos-hero-sub">Effective Date: April 18, 2026 · Last Updated: April 18, 2026</p>
      </div>

      {/* Body */}
      <div className="tos-body">
        <div className="tos-wrap">

          {/* Intro */}
          <div style={{ background: '#fff', border: '1px solid #E8E6DF', borderRadius: 14, padding: '20px 24px', marginBottom: 32 }}>
            <p style={{ fontSize: 14, color: '#4A4840', lineHeight: 1.8 }}>
              Welcome to Loan Closing Agent LLC. Please read these Terms of Service carefully before using our platform. 
              By creating an account or using our services, you acknowledge that you have read, understood, and agree to be bound by these Terms.
            </p>
          </div>

          {/* Sections */}
          {SECTIONS.map((s, i) => (
            <div key={i} className="tos-section">
              <h2>{s.title}</h2>
              <p>{s.content}</p>
            </div>
          ))}

          {/* Signature */}
          <div style={{ background: '#0D1B3E', borderRadius: 14, padding: '20px 24px', textAlign: 'center' }}>
            <div style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: 18, color: '#C9A84C', marginBottom: 4 }}>Loan Closing Agent LLC</div>
            <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.4)' }}>Nancy Phillips — Founder & CEO · Jacksonville, Florida</div>
            <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.25)', marginTop: 8 }}>Veteran & Hispanic Owned Business</div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="tos-footer">
        <div className="tos-footer-links">
          <Link to="/">Home</Link>
          <Link to="/services">Services</Link>
          <Link to="/privacy">Privacy Policy</Link>
          <Link to="/accessibility">Accessibility</Link>
          <Link to="/contact">Contact</Link>
        </div>
        <p className="tos-updated">© 2026 Loan Closing Agent LLC · All rights reserved</p>
      </footer>
    </div>
  )
}
